import { render } from "./AddRoleResultModal.vue?vue&type=template&id=f03598e4&scoped=true"
import script from "./AddRoleResultModal.vue?vue&type=script&lang=js"
export * from "./AddRoleResultModal.vue?vue&type=script&lang=js"

import "./AddRoleResultModal.vue?vue&type=style&index=0&id=f03598e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03598e4"]])

export default __exports__